import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Button, Col } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { newUserPath } from '../../../../routes';

const DropdownBtn = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const handleMenuClick = ({ key }) => navigate(newUserPath(key));

  // A `menu` descriptor rather than an `overlay` element: antd 4.24
  // deprecated passing the menu as JSX.
  const menu = {
    onClick: handleMenuClick,
    items: [
      { key: 'student', label: 'Student' },
      { key: 'teacher', label: 'Teacher' },
    ],
  };

  return (
    <Col className="gx-mr-3 gx-mb-4">
      <Dropdown menu={menu} onOpenChange={setIsOpen} trigger={['click']}>
        <span className="gx-d-inline-flex">
          <Button type="primary" className="gx-mb-0">
            Add New User
            {' '}
            {isOpen ? <UpOutlined className="gx-fs-xs" /> : <DownOutlined className="gx-fs-xs" />}
          </Button>
        </span>
      </Dropdown>
    </Col>
  );
};

export default DropdownBtn;
